import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import {
  eQuanLyHocPhanhActionIds,
  IQuanLyHocPhanhActionTypes,
} from "../../action-types/quyet-dinh/IQuanLyHocPhanActions";
import { quanLyHocPhanApi } from "../../../api/quyet-dinh/quanLyHocPhanApi";
import { IQuanLyHocPhanSelectRequest } from "../../../model/request/quyet-dinh/IQuanLyHocPhanSelectRequest";
import { ISMT_QuyetDinh_QuanLyHocPhan_Vm } from "../../../model/respone/quyet-dinh/quan-ly-hoc-phan/ISMT_QuyetDinh_QuanLyHocPhan_Vm";

export function* quanLyHocPhanSaga(): any {
  yield takeLatest(eQuanLyHocPhanhActionIds.LOAD_START, loadWorker);
  yield takeLatest(eQuanLyHocPhanhActionIds.DELETE_START, deleteWorker);
  yield takeLatest(eQuanLyHocPhanhActionIds.SAVE_START, saveWorker);
}

function* loadWorker(action: IQuanLyHocPhanhActionTypes): any {
  const res: IBaseRespone = yield call(
    quanLyHocPhanApi.SelectVm,
    action.payload as IQuanLyHocPhanSelectRequest
  );
  if (res.is_success) {
    yield put(rootActions.quyetDinh.quanLyHocPhan.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.quyetDinh.quanLyHocPhan.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}

// function* saveWorker(action: IQuanLyHocPhanhActionTypes): any {
//   let res: IBaseRespone;
//   const payload = action.payload as ISMT_QuyetDinh_QuanLyHocPhan_Vm[];
//   if (payload.quyet_dinh.id > 0) {
//     res = yield call(quanLyHocPhanApi.Update, payload);
//   } else {
//     res = yield call(quanLyHocPhanApi.Insert, payload);
//   }
//   if (res) {
//     if (res.is_success) {
//       yield put(rootActions.quyetDinh.quanLyHocPhan.SAVE_SUCCESS(res.data));
//     } else {
//       yield put(
//         rootActions.quyetDinh.quanLyHocPhan.SAVE_ERRR(res.message ?? "Có lỗi")
//       );
//     }
//   }
// }
function* saveWorker(action: IQuanLyHocPhanhActionTypes): any {
  const payload = Array.isArray(action.payload)
    ? (action.payload as ISMT_QuyetDinh_QuanLyHocPhan_Vm[])
    : [action.payload as ISMT_QuyetDinh_QuanLyHocPhan_Vm];

  try {
    // duyệt từng quyết định trong payload
    for (const item of payload) {
      let res: IBaseRespone;

      if (item.quyet_dinh?.id && item.quyet_dinh.id > 0) {
        // Update
        res = yield call(quanLyHocPhanApi.Update, item);
      } else {
        // Insert
        res = yield call(quanLyHocPhanApi.Insert, item);
      }

      if (res) {
        if (res.is_success) {
          yield put(rootActions.quyetDinh.quanLyHocPhan.SAVE_SUCCESS(res.data));
        } else {
          yield put(
            rootActions.quyetDinh.quanLyHocPhan.SAVE_ERRR(
              res.message ?? "Có lỗi"
            )
          );
          return;
        }
      }
    }
  } catch (error: any) {
    yield put(
      rootActions.quyetDinh.quanLyHocPhan.SAVE_ERRR(error.message ?? "Có lỗi")
    );
  }
}

function* deleteWorker(action: IQuanLyHocPhanhActionTypes): any {
  const res: IBaseRespone = yield call(
    quanLyHocPhanApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.quyetDinh.quanLyHocPhan.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.quyetDinh.quanLyHocPhan.DELETE_ERRR(res.message ?? "Có lỗi")
    );
  }
}
